import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AuthenticityRequestSuccess() {
  const { t } = useTranslation();
  const location = useLocation();
  const artwork = [location.state?.artist, location.state?.artworkTitle]
    .filter(Boolean)
    .join(" — ");

  return (
    <main className="min-h-screen bg-[#f7f7f5] px-4 py-12">
      <div className="mx-auto max-w-2xl rounded-2xl border border-gray-200 bg-white p-8 text-center md:p-12">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#faf6ec] text-[#9b8350]">
          ✓
        </div>
        <h1
          className="mt-6 text-3xl font-light text-gray-950"
          style={{ fontFamily: "Georgia, serif" }}
        >
          {t("authenticityRequest.success.title")}
        </h1>
        <p className="mt-4 text-sm leading-6 text-gray-600">
          {t("authenticityRequest.success.text")}
        </p>
        {artwork && <p className="mt-3 text-sm font-medium text-gray-900">{artwork}</p>}
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/my-collection"
            className="rounded-xl bg-black px-5 py-3 text-sm font-medium text-white"
          >
            {t("authenticityRequest.success.dashboard")}
          </Link>
          <Link
            to="/collections"
            className="rounded-xl border border-gray-300 px-5 py-3 text-sm font-medium text-gray-900"
          >
            {t("authenticityRequest.success.collection")}
          </Link>
        </div>
      </div>
    </main>
  );
}
